module.exports = __webpack_public_path__ + "static/media/e845140cdea968bfb0a8144fb06a7064.e845140c.mp4";